import React, { useState } from "react";
export default function Checkout() {
  let total = 0;
  const cart = JSON.parse(localStorage.getItem("cart")) || [];
  for (const item of cart){
    total += parseFloat(item.price);
  }
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const handlePayClick = async (email) => {
    setLoading(true);

    localStorage.setItem("email", email);
    if (email && Number(total) > 0 && cart.length > 0) {
      try {
        const response = await fetch(
          "https://high-and-fly-1.onrender.com/api/contact/payment/create-payment-intent/",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              amount: parseFloat(total),
              currency: "USD",
              user_email: email,
            }),
          }
        );

        const data = await response.json();
        if (data.clientSecret) {
        // send user to '/payment' with data.clientSecret
          window.location.href = `/payment`;
          localStorage.setItem("clientSecret", data.clientSecret);
        } else {
          alert("Error creating payment intent.");
        }
      } catch (error) {
        console.error("Error:", error);
        alert("Error creating payment intent.");
      } finally {
        setLoading(false);
      }
    };
  };

  return (
    <div className="container">
      <h1>React Stripe Payment</h1>
      <p>
        <strong>Amount:</strong> {total}
      </p>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (!email || email.trim() === "") {
            return;
          }

          handlePayClick(email);
        }}
      >
        <label htmlFor="email">Enter your email:</label>
        <input
          onChange={(e) => {
            setEmail(e.target.value);
          }}
          value={email}
          name="email"
          id="email"
          type="email"
        />
        <button type="submit" disabled={loading}>
          {loading ? "Loading..." : "Pay"}
        </button>
      </form>
    </div>
  );
};

